import { render, staticRenderFns } from "./tablereport.vue?vue&type=template&id=d38a2e2c&scoped=true&"
import script from "./tablereport.vue?vue&type=script&lang=js&"
export * from "./tablereport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d38a2e2c",
  null
  
)

export default component.exports